<script>
	// From Lucide
	import { Clock } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Clock class={iconClass} />
